import axios from "axios";
import { apiAddress } from "../../config/server";

import { ICalendarLink } from "../../types/calendar/Calendar";

export default class CalendarApi {
  static ListAddress = `${apiAddress}/api/calendar`;

  static GenerateAddress = `${apiAddress}/api/calendar/create`;

  static DeleteAddress = `${apiAddress}/api/calendar/`;

  static getMyLinks(): Promise<ICalendarLink[]> {
    return axios.get(this.ListAddress).then((response) => {
      if (response.status == 200 && response.data.success) {
        const { data } = response.data;
        return data;
      }
      throw new Error(response.data.message);
    });
  }

  static generateLink(): Promise<string> {
    return axios.post(this.GenerateAddress).then((response) => {
      if (response.status == 200 && response.data.success) {
        const { data } = response.data;
        return data;
      }
      throw new Error(response.data.message);
    });
  }

  static deleteLink(token: string): Promise<boolean> {
    return axios.delete(this.DeleteAddress + token).then((response) => {
      if (response.status == 200 && response.data.success) {
        const { data } = response.data;
        return data;
      }
      throw new Error(response.data.message);
    });
  }
}
